import { render, staticRenderFns } from "./setConfig.vue?vue&type=template&id=afeee21c"
import script from "./setConfig.vue?vue&type=script&lang=js"
export * from "./setConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports